import React from 'react';
import { useSelector } from 'react-redux';
import { deferTracking, sendGAEvent } from '@noths/polaris-client-google-analytics';

import { DeliveryInfo } from 'src/components/molecules/DeliveryInfo/DeliveryInfo';
import type { ReduxApplicationState } from 'src/redux/combinedReducer';
import { selectProduct } from 'src/redux/product/selectors';

export const DeliveryInfoContainer = () => {
  const product = useSelector((state: ReduxApplicationState) => selectProduct(state));

  const deliveryInfo = product.shippingInfo || undefined;

  const onVisible = () => {
    deferTracking(() =>
      sendGAEvent({
        event: 'custom_event',
        event_category: 'Delivery info',
        event_label: 'not set',
        event_action: 'Impression',
      }),
    );
  };

  return <DeliveryInfo deliveryInfo={deliveryInfo} onVisible={onVisible} />;
};
